import React from 'react';

export const Instagram: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" style={props.style}>
    <path d="M150,227.63a76.88,76.88,0,0,0,76.8-76.8h57.6V45.23c0-21.13-17.22-28.8-28.8-28.8H44.4c-21.13,0-28.8,17.23-28.8,28.8v211.2c0,21.13,17.22,28.8,28.8,28.8H255.6c21.13,0,28.8-17.22,28.8-28.8V170H265.2v86.29c-.11,4.43-1.87,9.71-9.6,9.71H44.51c-4.43-.11-9.71-1.87-9.71-9.6V150.83H73.2A76.88,76.88,0,0,0,150,227.63Zm0-19.2a57.6,57.6,0,1,1,57.6-57.6A57.67,57.67,0,0,1,150,208.43ZM34.8,131.63V45.35c.11-4.43,1.87-9.72,9.6-9.72H255.49c4.43.11,9.71,1.87,9.71,9.6v86.4H224.37a76.81,76.81,0,0,0-148.74,0Z"/>
    <rect x="226.8" y="54.83" width="19.2" height="19.2"/>
    <path d="M150,170a19.2,19.2,0,0,1-12.8-33.51l-12.8-14.31a38.42,38.42,0,0,0,38.4,64.84l-6.4-18.11A19,19,0,0,1,150,170Z"/>
  </svg>
);
